import type {
  SiteUsersState,
  SiteUsersSettings,
  AccessGroups,
  ActiveGroup,
  UserFieldsStoreType,
} from './types';

export const getSiteUsersSettings = (
  state: SiteUsersState
): SiteUsersSettings => state.settings;

export const getIsSiteUsersActivated = (state: SiteUsersState): boolean =>
  getSiteUsersSettings(state).version >= 1;

export const getActiveAccessGroup = (state: SiteUsersState): ActiveGroup =>
  state.accessGroups.activeGroup;

export const getSiteAccessGroups = (state: SiteUsersState): AccessGroups =>
  state.accessGroups.groups;

const getSiteUsersIsDisabled = (state: SiteUsersState): boolean =>
  getSiteUsersSettings(state).isDisabled;

export const selectIsUsersActivated = (state: any): boolean =>
  getIsSiteUsersActivated(state.SiteUsersStore);

// Safe because this doesn't return a new object:
// eslint-disable-next-line webflow/selector-memoization
export const selectActiveAccessGroup = (state: any): ActiveGroup =>
  getActiveAccessGroup(state.SiteUsersStore);

// Safe because this doesn't return a new object:
// eslint-disable-next-line webflow/selector-memoization
export const selectAccessGroups = (state: any): AccessGroups =>
  getSiteAccessGroups(state.SiteUsersStore);

export const selectIsUsersDisabled = (state: any): boolean =>
  getSiteUsersIsDisabled(state.SiteUsersStore);

const getUserFieldState = (state: SiteUsersState): UserFieldsStoreType =>
  state.userFields;

export const selectUserFields = (state: any) =>
  getUserFieldState(state.SiteUsersStore).fields;
